// extracted by mini-css-extract-plugin
export default {"locationText":"Common-module__locationText___QKkYj","link":"Common-module__link___2zo16","locationSecondaryText":"Common-module__locationSecondaryText___1bchR"};